'use client';

import { FC, useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button, ButtonProps } from './Buttons';
import { PdfViewer } from '@bw/elements';
import styles from './PdfViewerButton.module.scss';

export const PdfViewerButton: FC<ButtonProps> = (props) => {
	const [open, setOpen] = useState(false);
	const pdfAsset = props.data.fields.pdfLink;
	const url = (pdfAsset && 'fields' in pdfAsset ? pdfAsset.fields.file?.url : undefined) ?? props.data.fields.url ?? '';
	const assetTitle = pdfAsset && 'fields' in pdfAsset ? pdfAsset.fields.title : undefined;
	const title = assetTitle ?? props.data.fields.title;

	const onClick = useCallback(() => {
		props.onClick?.();
		setOpen(true);
	}, [props.onClick]);

	const close = useCallback(() => setOpen(false), []);

	useEffect(() => {
		if (!open) return;
		const onKey = (e: KeyboardEvent) => {
			if (e.key === 'Escape') close();
		};
		document.addEventListener('keydown', onKey);
		const prevOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		return () => {
			document.removeEventListener('keydown', onKey);
			document.body.style.overflow = prevOverflow;
		};
	}, [open, close]);

	const modal = open && url && (
		<div
			className={styles.overlay}
			onClick={close}
			role="dialog"
			aria-modal="true"
			aria-label={title}
		>
			<div className={styles.modal} onClick={(e) => e.stopPropagation()}>
				<button
					className={styles.closeBtn}
					onClick={close}
					aria-label="Close"
					title="Close"
				>
					×
				</button>
				<PdfViewer url={url} title={title} fallbackHref={url} />
			</div>
		</div>
	);

	return (
		<>
			<Button {...props} onClick={onClick} />
			{modal && typeof document !== 'undefined'
				? createPortal(modal, document.body)
				: null}
		</>
	);
};
